module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/mobile/dashkit-alt-21c6719b22b9ea112c06e92958af0c1a.jpg";